<header class="navbar">
  <section class="container-fluid row">
    <article class="col-7 col-xl-6 col-xxl-6 col-md-5 col-sm-5">
      <img
      routerLink="/zona-de-aprendizaje"
      src="../../../../assets/images/EDUTEGIA 1.png"
      class="logo"
      alt="Logo Edutegia"

      >
    </article>
      <article class="search-mobile col-md-1 col-1">
        <button class="search-icon"><img (click)="toggleSearch()" src="../../../assets/icons/search-icon-mobile.svg" alt="search-icon"></button>
        <input name="mobileSearcher" [(ngModel)]="searchTerm" type="text" (input)="onSearchTermChange()" (keyup.enter)="searchCourses()" [class.expanded]="isExpanded" class="search-input" placeholder="Búsqueda rápida">
        <button *ngIf="isExpanded" (click)="closeSearch()" class="close-icon">×</button>
        <section *ngIf="suggestedCategories.length && isExpanded">
          <div *ngFor="let suggestion of suggestedCategories, let i = index" (click)="selectSuggestion(suggestion)" class="suggestion mobile-sugg">
           {{ suggestion}}
         </div>
        </section>
      </article>
      <article class="col-xxl-4 col-xl-4 col-md-4 col-sm-3 search font">
            <img src="../../../assets/icons/Search-Icon.svg" alt="search-icon">
            <input name="searcher" [(ngModel)]="searchTerm" type="text" (input)="onSearchTermChange()" (keyup.enter)="searchCourses()" placeholder="Búsqueda rápida">
            <section *ngIf="suggestedCategories.length">
              <div *ngFor="let suggestion of suggestedCategories, let i = index" (click)="selectSuggestion(suggestion)" class="suggestion">
               {{ suggestion}}
             </div>
            </section>
      </article>
      <article class="col-xxl-2 col-xl-2 col-md-3 col-sm-3 col-4 font right">
        <div class="dropdown">
          <a type="button" class="user" data-bs-toggle="dropdown">
            <!-- [src]=imgUser -->
            <img [src]="imgUser" (error)="setDefaultImage($event)" class="img-user" alt="imágen usuario">
            <span class="user-name">{{infoUser.attributes.field_name}}</span>
          </a>
          <ul class="dropdown-menu menu">
            <div class="top-float">
              <span class="username">{{infoUser.attributes.field_name}}</span>
              <span class="email">{{infoUser.attributes.mail}}</span>
            </div>
            <div class="bottom-float">
              <li><a routerLink="/configuración" fragment="datos" class="dropdown-item">Mis datos</a></li>
              <li><a routerLink="/configuración" fragment="seguridad" class="dropdown-item">Seguridad</a></li>
              <li><a routerLink="/configuración" fragment="perfil" class="dropdown-item">Perfil</a></li>
            </div>
            <div class="logout">
              <li><a type="button" class="dropdown-item" (click)="logout()">Cerrar sesión</a></li>
            </div>
          </ul>
        </div>
        <div class="dropdown">
          <a type="button" data-bs-toggle="dropdown">
            <img src="../../../assets/icons/notifications.svg" class="notifications" alt="imágen usuario">
            <span class="pend-icon" *ngIf="activitiesExpired.length || activitiesCloseToExpired.length">{{activitiesExpired.length + activitiesCloseToExpired.length}}</span>
          </a>
          <ul class="dropdown-menu menu-notifications">
            <div class="top-notifications">
              <a type="button" class="title-notifications" routerLink="/notificaciones">Notificaciones</a>
            </div>
            <div class="bottom-float container-notifications">
              <div class="notification-pend color-notification" *ngFor="let activity of activitiesExpired" [routerLink]="['/cursos' + activity.coursePath + activity.lessonPath + activity.attributes.path.alias]">
                <span class="text-notification">La actividad: <b class="name-activity">{{activity.attributes.title}}</b> venció hace <b>{{activity.daysLeft * -1}} días.</b><br><b>Estado: </b>Sin entregar</span>
              </div>
              <div class="notification-pend color-notification2" *ngFor="let activity of activitiesCloseToExpired" [routerLink]="['/cursos' + activity.coursePath + activity.lessonPath + activity.attributes.path.alias]">
                <span class="text-notification">La actividad: <b class="name-activity">{{activity.attributes.title}}</b> vence en <b>{{activity.daysLeft}} día(s).</b><br><b>Estado: </b>Sin entregar</span>
              </div>
              <span class="up-to-date" *ngIf="!(activitiesExpired.length || activitiesCloseToExpired.length)">Estás al día</span>
            </div>
          </ul>
        </div>
        <a type="button" class="toggle-button" (click)="isMenuOpen = !isMenuOpen" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <img src="../../../assets/icons/hamburger-menu.svg" alt="menú-hamburguesa">
        </a>
      </article>
      <app-mobile-menu [isOpen]="isMenuOpen" (closeMenu)="isMenuOpen = false"></app-mobile-menu>
  </section>
</header>
<app-loader *ngIf="isLoading"></app-loader>
